import { callOrganizationServiceApi } from '../../../apis/organizationService';

/**
 * Replaces the admins assigned to one sales metro (GOTU-7541).
 *
 * The body is the whole set, not a diff — `[]` unassigns everyone. Each id is
 * an auth-service internal_user row `id`, not its `userId`: the handler checks
 * them against organization-service's mirror of that table, which is keyed by
 * the row id.
 *
 * Refusals carry `{ error }`: 403 without the `sales_metro:assign_gotu_admin`
 * claim, 400 for an id that is malformed or not a current GoTu admin, 404 for
 * an unknown metro.
 *
 * @param {string} salesMetroId
 * @param {string[]} internalUserIds
 * @returns {Promise<import('../types/SalesMetro.api').IPutSalesMetroAdminsApiResponse>}
 */
export const putSalesMetroAdmins = (salesMetroId, internalUserIds) =>
  callOrganizationServiceApi('put', `admin/sales-metros/${salesMetroId}/admins`, {
    data: { internalUserIds },
  });
